<template>
  <div class="about">
    <!-- HEADER ================================================== -->
    <section class="section section_header section_header__about">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <!-- Heading -->
            <h2 class="h1 section__heading section_header__heading text-center">
              Über uns
            </h2>
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .container -->
      <div class="section_header__bg about_bg"></div>
    </section>

    <!-- section story -->
    <section class="section_story">
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
            <div class="section_story__quote">
              <h1 class="h3 quote__title">
                Griechische Gastfreundschaft in Aurich seit 1981
              </h1>
              <p class="quote__text">
                Seit fast 40 Jahren bieten wir unseren Gästen am Pferdemarkt,
                mitten in Aurich, eine erstklassige griechische Küche an. Als
                Familienbetrieb legen wir Wert auf eine gemütliche Atmosphäre
                und lassen Sie an der griechischen Gast&shy;freundschaft
                teilhaben.
              </p>
              <p class="quote__text">
                Unser Restaurant in Aurich hat eine große Auswahl an
                Sitz&shy;möglichkeiten. Wir haben gemütliche Sitzecken mit
                Nischen für insgesamt über 120 Personen.<br />Treffen Sie sich
                mit der Familie oder Ihren Freunden? Dann ist die große Sitzecke
                für über 20 Personen interessant. Im Sommer haben wir wahlweise
                sonnige und schattige Sitzmöglichkeiten in unserem gemütlichen
                Garten mit über 50 Sitzplätzen.
              </p>
              <p class="quote__text">
                Unsere Stammgäste und natürlich unsere täglich neuen Gäste
                machen uns zu dem was wir heute sind: Eines der ältesten
                Restaurants in Aurich.
              </p>

              <p></p>
              <h4 class="h3 qoute__author">
                Restaurant Dafni
              </h4>
            </div>
          </div>
        </div>
        <!-- / .row -->
      </div>
      <!-- .container -->
    </section>
  </div>
</template>

<script>
export default {
  name: "About",
  metaInfo: {
    title: "Über uns - Restaurant Dafni Aurich"
  }
};
</script>
